import script from "./AncestryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AncestryDetails.vue?vue&type=script&setup=true&lang=js"

import "./AncestryDetails.vue?vue&type=style&index=0&id=1228684a&lang=scss"

const __exports__ = script;

export default __exports__